import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import configAxiosInterceptors from 'config/axios/interceptors';
import { loadAppScaffold } from 'store/modules/appScaffold/actions';
import { logout as logoutAction } from 'store/modules/auth/actions';
import { loadMyUser, mergeMyUser } from 'store/modules/myUser/actions';
import { setNetworkReady } from 'store/modules/network/actions';

export const USER_ID_URL = 'https://myfarmbot.com/userId';

interface Props {
  children: JSX.Element;
}

/**
 * A component for Auth0, axios initialisation, and init API calls.
 */
const Auth0TokenHandler = ({ children }: Props) => {
  const dispatch = useDispatch();
  const { getAccessTokenSilently, user: auth0User, loginWithRedirect } = useAuth0();
  const previousAuth0SubRef = useRef<string | undefined>();

  useEffect(() => {
    configAxiosInterceptors(getAccessTokenSilently, loginWithRedirect);
  }, [getAccessTokenSilently, loginWithRedirect]);

  useEffect(() => {
    if (!auth0User) {
      previousAuth0SubRef.current = undefined;
      return;
    }

    const userId = +auth0User[USER_ID_URL];
    if (!userId) return;

    const auth0Sub = auth0User.sub;
    if (previousAuth0SubRef.current && previousAuth0SubRef.current !== auth0Sub) {
      dispatch(logoutAction()); // Reset Redux state.
    }
    previousAuth0SubRef.current = auth0Sub;

    dispatch(setNetworkReady(true));
    dispatch(mergeMyUser({ id: userId }));
    dispatch(loadMyUser()); // Load user profile.
    dispatch(loadAppScaffold()); // Load Core API.
  }, [auth0User, dispatch]);

  return children;
};

export default Auth0TokenHandler;
